import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Amrah from "../../../assets/shortlist_23/amrah.png";
import Chioma from "../../../assets/shortlist_23/chioma.png";
import Nkem from "../../../assets/shortlist_23/nkem.png";
import Safiya from "../../../assets/shortlist_23/safiya.png";

const obyNominees = [
  {
    name: "Amrah Aliyu",
    title: "Salma Attah foundation for Women and girls support (SAFWGS)",
    imgpath: Amrah,
  },
  {
    name: "Chioma Agwuegbo",
    title: "Tech Project Women’s Initiative (TechHerNG)",
    imgpath: Chioma,
  },
  {
    name: "Nkem Okocha",
    title: "Mamamoni Empowerment Foundation",
    imgpath: Nkem,
  },
  {
    name: "Safiya Ibn Garba",
    title:
      " Empowering Women for Excellence Initiative Nigeria, Generations For Peace Jordan, and Global Young Generation For Peace Development Initiative Nigeria",
    imgpath: Safiya,
  },
];

const ObyNominees = () => {
  return (
    <Grid item xs={12} md={12} marginTop={{ xs: "10%", sm: "1%" }}>
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Oby Ezekwesili Award for Women Advocacy (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {obyNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default ObyNominees;
